import Bowser from 'bowser';
import PcPlayer from './pcVideoAsync';
import FlashPlayer from './flashVideoAsync';

const browser = Bowser.getParser(window.navigator.userAgent);
const isIE = browser.is('Internet Explorer');

let Player = PcPlayer;

// baidu爬虫时也使用flash播放器 ua: Baiduspider-render
// IE下全部使用flash
if (
    isIE ||
    (typeof window !== 'undefined' && window.navigator && window.navigator.userAgent.includes('Baiduspider-render'))
) {
    Player = FlashPlayer;
}

export default Player;
